export default __webpack_public_path__ + "static/media/sign.119124f8.png";